import { connect } from 'react-redux';

import { VODCSSModules } from 'shared/utils/wix-connect';

import { mainItemTypeValues } from 'default-settings';

import { isVideoPausedOptimistic, isVideoPlayingOptimistic } from 'widget/selectors/video-playback-status';

import ExternalPlayer from './player-external';
import InternalPlayer from './player-internal';
import ResizedImage from 'shared/components/resized-image/resized-image';

import styles from './player.styl';

@connect(
  state => ({
    isVideoPlayingOptimistic: isVideoPlayingOptimistic(state),
    isVideoPausedOptimistic: isVideoPausedOptimistic(state),
  })
)
@VODCSSModules(styles)
export default class Player extends React.Component {

  static propTypes = {
    appSettings: React.PropTypes.object,
    channelData: React.PropTypes.object,
    videoItem: React.PropTypes.object.isRequired,

    canShowChannelCover: React.PropTypes.bool,
    isVideoPlayingOptimistic: React.PropTypes.bool,
    isVideoPausedOptimistic: React.PropTypes.bool,
    showPoster: React.PropTypes.bool,
    simple: React.PropTypes.bool,

    children: React.PropTypes.any,

    width: React.PropTypes.number,
    height: React.PropTypes.number,
  };

  static defaultProps = {
    showPoster: true,
  };

  get showChannelCover() {
    const { appSettings, canShowChannelCover } = this.props;
    return canShowChannelCover && appSettings.numbers.mainItemType === mainItemTypeValues.CHANNEL_COVER;
  }

  shouldShowInitialOverlay() {
    const { isVideoPlayingOptimistic, isVideoPausedOptimistic } = this.props;
    return !isVideoPlayingOptimistic && !isVideoPausedOptimistic;
  }

  get posterUrl() {
    const { videoItem, channelData } = this.props;

    const { customCoverUrl } = videoItem;
    let { coverUrl } = videoItem;

    coverUrl = customCoverUrl || coverUrl;

    if (this.showChannelCover) {
      coverUrl = channelData.customCoverUrl || channelData.coverUrl || coverUrl;
    }

    return coverUrl;
  }

  get initialOverlay() {
    const { children } = this.props;

    if (!children) {
      return null;
    }

    const { channelData } = this.props;
    const originProps = _.pick(this.props, 'showChannelCover', 'appSettings', 'videoItem');

    return React.cloneElement(children, _.assign({
      channelData,
      showChannelCover: this.showChannelCover,
    }, originProps));
  }

  get poster() {
    const { videoItem: { mediaExternUrl } } = this.props;
    const isExternal = Boolean(mediaExternUrl);

    const {
      simple,
      showPoster,
      width,
      height,
    } = this.props;

    if (!showPoster) {
      return null;
    }

    if (simple && isExternal) {
      return null;
    }

    const posterUrl = this.posterUrl;

    if (!posterUrl) {
      return null;
    }


    return (
      <ResizedImage styleName="cover-image"
                    src={posterUrl}
                    width={width}
                    height={height} />
    );
  }

  get overlay() {
    if (!this.shouldShowInitialOverlay()) {
      return null;
    }

    return (
      <div styleName="overlay"
           style={this.styles}>
        {this.initialOverlay}
        {this.poster}
      </div>
    );
  }

  get styles() {
    const { width, height } = this.props;
    return {
      width,
      height,
    };
  }

  get player() {
    const { videoItem: { mediaExternUrl } } = this.props;
    const isExternal = Boolean(mediaExternUrl);

    const PlayerComponent = isExternal ? ExternalPlayer : InternalPlayer;

    const props = _.omit(this.props, 'intl', 'styles');

    return <PlayerComponent {...props} />;
  }

  render() {
    return (
      <section styleName="player"
               style={this.styles}>
        {this.overlay}
        <div styleName="player-wrapper">
          {this.player}
        </div>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/widget/player-widget/components/new-player/player.js